export function computeBmi(heightInches, weightLbs) {
  const h = Number(heightInches);
  const w = Number(weightLbs);
  if (!h || !w || h <= 0 || w <= 0) return null;
  return Math.round((703 * w / (h * h)) * 10) / 10;
}

const FULL = { canEditValues: true, canVerify: true, canEditProfile: true,
  canSeeFinancial: true, canOpenConcierge: true, canEnroll: false, canEditMembership: true };
const VERIFY_ONLY = { canEditValues: false, canVerify: true, canEditProfile: false,
  canSeeFinancial: false, canOpenConcierge: false, canEnroll: false, canEditMembership: false };
const NONE = { canEditValues: false, canVerify: false, canEditProfile: false,
  canSeeFinancial: false, canOpenConcierge: false, canEnroll: false, canEditMembership: false };

// Verification (the blue dot) is set by ProZpects staff/partners only — NOT by
// coaches. A coach is an evaluator/recruiter; the blue dot gives coaches
// confidence precisely because a coach did not set it. So coach = read-only.
// This is the ROLE-NAME fallback, used only when the server sent no `perms`
// block (e.g. an older cached response). See permsFromServer below for the
// authoritative, per-athlete source of truth.
export function athleteDetailPermissions(role) {
  if (role === 'admin' || role === 'internal_staff') return FULL;
  if (role === 'partner') return VERIFY_ONLY;
  return NONE; // coach, player_parent, guardian, base_user, unknown
}

// The server's `perms` block (GET /athletes/:id/profile) is the authority: a
// partner's rights depend on whether THIS athlete is theirs, which the role name
// cannot tell. Membership writes stay staff-only on the server
// (POST /admin/users/:id/membership), so they stay staff-only here too.
export function permsFromServer(serverPerms, role) {
  if (!serverPerms) return athleteDetailPermissions(role);
  const staff = role === 'admin' || role === 'internal_staff';
  return {
    canEditValues: !!serverPerms.can_edit,
    canVerify: !!serverPerms.can_verify,
    canEditProfile: !!serverPerms.can_edit,
    canSeeFinancial: !!serverPerms.can_see_financial,
    canOpenConcierge: !!serverPerms.can_open_concierge,
    canEnroll: !!serverPerms.can_enroll,
    canEditMembership: staff,
  };
}

// Roles that may OPEN the athlete-detail page (read-only for those who can't
// edit/verify). Coach/partner can view; they just have different capabilities
// once there. Matches the RoleProtectedRoute allow-list on /athletes/:id.
export function canAccessAthleteDetail(role) {
  return ['admin', 'internal_staff', 'coach', 'partner'].includes(role);
}

// Roles that may put an athlete on a report (the /lists
// entity). Partners manage their own lists (backend scopes to created_by);
// coach reaches this page but must NOT see the add-to-report control — every
// /api/reports write would 403 for them.
export function canManageReports(role) {
  return ['admin', 'internal_staff', 'partner'].includes(role);
}
